import React, { Component } from "react";
import { connect } from "react-redux";
import { Grid, Hidden, Box } from "@material-ui/core";
import {Helmet} from 'react-helmet';
import ReactGA from 'react-ga';
import ReactPageScroller from "react-page-scroller";

import { parentContainer } from "../../config/theme";

import Header from "../../components/Header";
import LandingBanner from './LandingBanner';
import LandingDiner from './LandingDiner';
import LandingChef from "./LandingChef";
import LandingFirstText from "./LandingFirstText"
import LandingFooter from "./LandingFooter";
import Footer from "../../components/Footer/Footer";

import { GA_CODE } from '../../config/constants';;

const BannerLanding = React.memo(LandingBanner);
const ChefLanding = React.memo(LandingChef);
const DinerLanding = React.memo(LandingDiner);
const FirstText = React.memo(LandingFirstText);
const FooterLanding = React.memo(LandingFooter);

class Landing extends Component {
  constructor(props) {
    super(props);

    this.state = {
      campaign: null,
      openLogin: false,
      openSignUp: false,
      viaChannel: false,
      currentPage: null
    };

    this.removeChannel = this.removeChannel.bind(this);
    ReactGA.initialize(GA_CODE);
  }

  removeChannel() {
    this.setState({
      campaign: null,
      openLogin: false,
      openSignUp: false
    });
  }

  componentDidMount() {
    ReactGA.pageview(window.location.pathname + window.location.search);
    window.onload = function() {
      window.scrollTo(0, 0);
    };

    const { location } = this.props;

    // handling channel code signup
    if (!!location && !!location.search) {
      const indexAmp = location.search.indexOf('&');
      if (indexAmp < 0) {
        const index = location.search.indexOf('campaign=');
        if  (index > -1) {
          let searchString = location.search;
          searchString = searchString.substring(1);
          if (searchString.indexOf('=') === 8) {
            const campArr = searchString.split('=');
            if (campArr.length == 2) {
              if (campArr[0] === 'campaign') {
                const channelCode = campArr[1];
                this.setState({ campaign: channelCode, openSignUp: true, viaChannel: false });
              }
            } // end-if campArr length 2
          } // end-if searchString indexOf = 8
        }// end-if index > -1
      } else {
        let searchString = location.search;
        searchString = searchString.substring(1);
        const paramsArr = searchString.split('&');
        const stateToUpdate = {};

        if (paramsArr.length > 1) {
          const campaignIndex = paramsArr[0].indexOf('campaign');
          const signupIndex = paramsArr[1].indexOf('signup');

          if (campaignIndex > -1) {
            const campaignStr = paramsArr[0];

            if (campaignStr.indexOf('=') === 8) {
              const campArr = campaignStr.split('=');
              if (campArr[0] === 'campaign') {
                const channelCode = campArr[1];
                stateToUpdate.campaign = channelCode;
                stateToUpdate.openSignUp = true;
              } // end-if campArr 2
            } // end-if campStr.indexOf
          } // end-if campaignIndex

          if (signupIndex > -1) {
            const signupStr = paramsArr[1];

            if (signupStr.indexOf('=') === 6) {
              const signupArr = signupStr.split('=');
              if (signupArr[0] === 'signup') {
                const signupVal = signupArr[1];
                if (signupVal === 'channel') {
                  stateToUpdate.viaChannel = true;
                }
              } // end-if signupArr 2
            } // end-if signupStr.indexOf
          } // end-if signupIndex
          this.setState(stateToUpdate);
        } // end-if params length > 1
      }
    }

    const { userId, history } = this.props;

    if (userId) {
      history.push("/home/dashboard");
    }
  }

  handlePageChange = number => {
    this.setState({ currentPage: number });
  };

  render() {
    const { userId, history } = this.props;

    if (userId) {
      return <div>{history.push("/home/dashboard")}</div>;
    }

    return (
      <div style={parentContainer}>
        <Helmet>
          <title>Cuisine Crafters | Find A Personal Chef For At-Home Service</title>
          <meta name="description" content="Are you looking to hire a private chef for in-home service? Use Cuisine Crafters to find the perfect home chef for your needs. Choose from different styles and more." />
          <link rel="canonical" href="https://cuisinecrafters.net" />
          <meta name="robots" content="index, follow, max-snippet:-2, max-image-preview: large, max-video-preview:-1" />
        </Helmet>
        <Grid container>
          <Grid item xs={12}>
            <Header history={this.props.history} location={this.state} removeChannel={this.removeChannel} />
          </Grid>
        </Grid>

        {/*<ReactPageScroller
            pageOnChange={this.handlePageChange}
            containerHeight={'91.2vh'}
            containerWidth={'100vw'}
            renderAllPagesOnFirstRender={true}
        >*/}

          <BannerLanding {...this.props} />

          <FirstText />

          <DinerLanding />

          <ChefLanding />

          <FooterLanding {...this.props} />

        {/*</ReactPageScroller>*/}

        <Footer />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    userId: state.auth.userId
  };
};

const LandingPage = connect(mapStateToProps)(Landing);

export default LandingPage;
